import BookingsApiEndpoints from './booking.api';
import * as helpers from '../helpers';
import WishlistApiEndpoints from './wishlist.api';
import PaymentsApiEndpoints from './payments.api';

const GuestApi = {
  ...helpers,
  bookings: BookingsApiEndpoints,
  wishlist: WishlistApiEndpoints,
  payments: PaymentsApiEndpoints,
};

export default GuestApi;
